import React from 'react';
import { Modal } from './Modal';
import { Loader } from './Loader';

const formatSize = (bytes) => {
  if (!bytes && bytes !== 0) return '-';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let size = Math.max(bytes, 0);
  let idx = 0;
  while (size >= 1024 && idx < units.length - 1) {
    size /= 1024;
    idx += 1;
  }
  return `${size.toFixed(size < 10 && idx > 0 ? 1 : 0)} ${units[idx]}`;
};

export function FileUploadModal({
  show,
  title = 'Upload Files',
  onClose,
  selectedFiles = [],
  onFilesChange,
  helperText = 'Select one or more files.',
  accept,
  multiple = true,
  children,
  primaryActionLabel = 'Upload',
  onPrimaryAction,
  primaryDisabled,
  isUploading = false,
  secondaryActionLabel = 'Close',
}) {
  const safeOnFilesChange = typeof onFilesChange === 'function' ? onFilesChange : () => {};

  const handleFileInput = (e) => {
    const files = Array.from(e.target.files || []);
    safeOnFilesChange(files);
    e.target.value = '';
  };

  const handleClose = () => {
    if (isUploading) return;
    if (typeof onClose === 'function') onClose();
  };

  const disablePrimary = typeof primaryDisabled === 'boolean'
    ? primaryDisabled
    : (isUploading || selectedFiles.length === 0);

  return (
    <Modal
      show={show}
      onClose={handleClose}
      title={title}
      body={
        <div>
          <div className="mb-3">
            <input
              type="file"
              className="form-control"
              multiple={multiple}
              accept={accept}
              onChange={handleFileInput}
            />
            {helperText ? <div className="form-text">{helperText}</div> : null}
          </div>
          {children}
          {selectedFiles.length > 0 && (
            <div className="table-responsive">
              <table className="table table-sm">
                <thead>
                  <tr>
                    <th>File</th>
                    <th className="text-end">Size</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedFiles.map((file, idx) => (
                    <tr key={`${file.name}-${file.size}-${file.lastModified}-${idx}`}>
                      <td>{file.name}</td>
                      <td className="text-end">{formatSize(file.size)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      }
      footer={
        <>
          <button className="btn btn-secondary" onClick={handleClose} disabled={isUploading}>
            {secondaryActionLabel}
          </button>
          {typeof onPrimaryAction === 'function' && (
            <button
              className="btn btn-primary"
              onClick={onPrimaryAction}
              disabled={disablePrimary}
            >
              {isUploading ? (
                <>
                  <Loader size="sm" className="me-2" />
                  {primaryActionLabel}
                </>
              ) : (
                primaryActionLabel
              )}
            </button>
          )}
        </>
      }
    />
  );
}

